import { SET_NAVBAR_TAB, SET_NAVBAR_ITEMS } from "./types";
export function SETNAVBARTAB() {
	return {
		type: SET_NAVBAR_TAB,
	};
}
export function SETNAVBARITEMS() {
	return {
		type: SET_NAVBAR_ITEMS,
	};
}
export const UpdateNavBarItem = (data) => {
	return {
		type: SET_NAVBAR_ITEMS,
		payload: data,
	};
};
export const UpdateNavBarTab = (data) => {
	return {
		type: SET_NAVBAR_TAB,
		payload: data,
	};
};
